import { render, staticRenderFns } from "./ChallengeFooter.vue?vue&type=template&id=c7be79f0"
import script from "./ChallengeFooter.vue?vue&type=script&lang=js"
export * from "./ChallengeFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports